import $ from "jquery";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export default class HomeHero {
  $el = $("section.home-hero");

  constructor() {
    if (!this.$el.length) return;

    this.init();
  }

  init() {
    gsap.registerPlugin(ScrollTrigger);

    //this.setupLoadAnimation();
    //this.setupScrollAnimation();
  }

  setupLoadAnimation() {
    const title = this.$el.find(".title.animate");
    const gradStart = this.$el.data("title-grad-start");
    const gradEnd = this.$el.data("title-grad-end");

    gsap.fromTo(
      title,
      {
        backgroundImage: `linear-gradient(160deg, ${gradStart} 0%, ${gradStart} 100%)`,
        loop: -1,
      },
      {
        backgroundImage: `linear-gradient(160deg, ${gradEnd} 0%, ${gradStart} 150%)`,
        duration: 5,
        ease: "power2.inOut",
        repeat: -1,
        delay: 0.5,
        yoyo: true,
      }
    );
  }

  setupScrollAnimation() {
    const topTriangle = this.$el.find("#home-hero-top-triangle path").get(0);
    const bottomTriangle = this.$el
      .find("#home-hero-bottom-triangle path")
      .get(0);

    const topTrianglePoints = "M0.443,0,1484.668-62.324 H50.443Z";
    const bottomTrianglePoints = "M50.443-0.324, 1500, 103.123 H50.443Z";

    const scrollTriggerConfig = {
      trigger: this.$el,
      start: "top top",
      end: "bottom top",
      scrub: 2,
      markers: false,
    };

    gsap.to(topTriangle, {
      scrollTrigger: scrollTriggerConfig,
      attr: {
        d: topTrianglePoints,
      },
    });

    gsap.to(bottomTriangle, {
      scrollTrigger: scrollTriggerConfig,

      attr: {
        d: bottomTrianglePoints,
      },
    });
  }
}
